import React, { FC, ReactElement, ReactNode } from 'react';
import {
  ActionButton,
  CancelButton,
  CloseMarkCont,
  ModalBlackBG,
  ModalCont,
  ModalActions,
  ModalFooter,
  ModalHeader,
  XMarkCont,
} from './Modal.styles';
import Spinner from '../../components/Spinner/Spinner';
import { HeadingExtraBoldS } from '../../styles/globals';
import CloseMark from '@/assets/icons/closeMark.svg?react';

interface IButtonsNames {
  action: string;
  cancel: string;
}

interface IModal {
  closeModal: () => void;
  callToAction: () => void;
  children: ReactElement;
  active: boolean;
  buttonNames?: IButtonsNames;
  title?: string;
  top?: string;
  width?: string;
  noC2AButton?: boolean;
  absolute?: boolean;
  right?: string;
  loading?: boolean;
  footerStartContent?: ReactNode;
}

const Modal: FC<IModal> = ({
  children,
  active,
  closeModal,
  callToAction,
  buttonNames,
  title,
  top,
  width,
  noC2AButton,
  absolute,
  right,
  loading,
  footerStartContent,
}) => {
  const actionButtonName = buttonNames?.action || 'create';
  const cancelButtonName = buttonNames?.cancel || 'cancel';
  return (
    <>
      {active && (
        <>
          <ModalBlackBG onClick={closeModal} />
          <ModalCont width={width} top={top} absolute={absolute} right={right} id="ModalCont">
            <ModalHeader id="ModalHeader">
              <HeadingExtraBoldS id="HeadingExtraBoldS">{title || ''}</HeadingExtraBoldS>
              <CloseMarkCont data-testid="x-mark" id="CloseMarkCont" onClick={closeModal}>
                <CloseMark />
              </CloseMarkCont>
            </ModalHeader>
            {children}
            <ModalFooter id="ModalFooter">
              <div>{footerStartContent}</div>
              <ModalActions>
                {!noC2AButton && (
                  <ActionButton
                    data-testid="action-button"
                    id="ActionButton"
                    onClick={callToAction}
                    disabled={loading}
                  >
                    {loading ? <Spinner /> : actionButtonName}
                  </ActionButton>
                )}
                <CancelButton data-testid="cancel-button" id="CancelButton" onClick={closeModal}>
                  <XMarkCont>
                    <CloseMark />
                  </XMarkCont>
                  {cancelButtonName}
                </CancelButton>
              </ModalActions>
            </ModalFooter>
          </ModalCont>
        </>
      )}
    </>
  );
};

export default Modal;
